import { j as a } from "../../../../node_modules/react/jsx-runtime.js";
import { getLocale as o } from "../../../../utils/helper.js";
import r from "../Calender.module.scss.js";
const t = ["ح", "ن", "ث", "ر", "خ", "ج", "س"], l = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], n = () => {
  const e = o() === "ar" ? t : l;
  return /* @__PURE__ */ a.jsx("div", { className: "grid grid-cols-7 gap-y-050", children: e.map((s) => /* @__PURE__ */ a.jsx(
    "div",
    {
      className: `${r.daysCell}`,
      children: s
    },
    s
  )) });
};
export {
  n as default
};
//# sourceMappingURL=WeekName.js.map
